import { makeRequest } from 'utils/requestLogger';

export default (courseID, studentID, dateStart, dateEnd) =>
    makeRequest('get', `/api/courses/${courseID}/student-data/${studentID}?dateStart=${dateStart}&dateEnd=${dateEnd}`);


// WEBPACK FOOTER //
// ./src/app/services/courses/exportStudentReportData.js